import React from 'react';
import { Center, Box, HStack } from 'native-base';
import Pressable from '~/shared/Pressable';
import { H2, Caption } from '~/shared/Typography';
import { useAppNavigate } from '~/pages';
import { AppRouteProps } from '~/pages';
import { useTheme } from '@springbig/shared';

export type CardMenuProps = {
    title: string;
    path?: AppRouteProps;
    handleLogout?: () => void;
    testID?: string;
    toggleMenu?: () => void;
    badge?: number;
};

const CardMenu = ({ title, path, handleLogout, testID, toggleMenu, badge }: CardMenuProps) => {

    const navigation = useAppNavigate();

    const { menu_background_secondary, menu_text } = useTheme();

    const handlePress = (): void => {

        if (path) {
            toggleMenu && toggleMenu();

            path.includes('https://') ? window.open(path, '_blank') : navigation.navigate(path);
        }
    };

    return (
        <Pressable
            testID={testID}
            onPress={handleLogout ? handleLogout : handlePress}
            px={4}
            py={2}
            bg={menu_background_secondary}
            w={'100%'}
        >
            <Center alignItems={'center'} w={'100%'}>
                <HStack alignItems="center" space={2}>
                    <H2 color={menu_text}>
                        { title }
                    </H2>
                    {badge !== undefined && badge > 0 && (
                        <Box
                            backgroundColor="red"
                            borderRadius="999px"
                            width="20px"
                            height="20px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Caption color="white" fontSize="10px" fontWeight="bold">
                                {badge}
                            </Caption>
                        </Box>
                    )}
                </HStack>
            </Center>
        </Pressable>
    );
};

export default CardMenu;
